import domMixin from '../dom/dom-mixin';
import {rightTrim} from '../utils/string';


class CurrentLinkManager extends domMixin() {

	constructor({currentClass = 'current'}) {
		super();
		this.currentClass = currentClass;
		this.currentLinks = [];
	}


	init() {
		this.events.on(document, 'history:pagechange', this.onPageChange.bind(this));
	}


	onPageChange(event) {
		this.update(event.detail.url);
	}


	update(url = null) {
		if (url === null) {
			url = location.href;
		}
		url = rightTrim(url, '/');
		for (const link of this.currentLinks) {
			this.classList(link).remove(this.currentClass);
		}
		this.currentLinks = document.body.querySelectorAll('[href="' + url + '"]');
		for (const link of this.currentLinks) {
			this.classList(link).add(this.currentClass);
		}
	}

}

export default CurrentLinkManager;
